import Reveal from "@/components/Reveal";
import { CLIENT_LOGOS } from "@/lib/content";

// Client logos — real logos, evenly weighted. More can be appended in content.js (CLIENT_LOGOS).
const LogosStrip = () => {
  return (
    <section className="bg-white border-y border-[#2A2E7A]/8" data-testid="logos-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <Reveal>
          <p className="text-center text-[12px] font-semibold uppercase tracking-[0.2em] text-[#8A93A8]">
            Trusted by businesses across Aruba
          </p>
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-10 gap-y-12 items-center justify-items-center">
            {CLIENT_LOGOS.map((logo, i) => (
              <Reveal key={logo.name} delay={i * 0.06} className="w-full flex justify-center">
                <img
                  src={logo.src}
                  alt={`${logo.name} logo`}
                  title={logo.name}
                  data-testid={`client-logo-${i + 1}`}
                  loading="lazy"
                  className="h-14 sm:h-16 w-auto max-w-[160px] object-contain transition-transform duration-300 ease-out hover:scale-[1.05]"
                />
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default LogosStrip;
